<div class="actions">
  <div class="actions__anchor">
    <button
      type="button"
      class="actions__more"
      aria-label="More"
      (click)="toggle('more')"
    >
      <ui-icon [name]="'dots-vertical'"></ui-icon>
    </button>
    @if (openMenu() === 'more') {
      <ul class="menu menu--more">
        <li>
          <button
            type="button"
            class="menu__item"
            (click)="openAbout()"
          >
            <ui-icon
              [name]="'chat_bubble_event'"
              [size]="iconSize"
              [color]="menuIconColor"
            ></ui-icon
            >{{ aboutText | translate }}
          </button>
        </li>
        <li>
          <button
            type="button"
            class="menu__item"
            (click)="openHelp()"
          >
            <ui-icon
              [name]="'help-box-multiple'"
              [size]="iconSize"
              [color]="menuIconColor"
            ></ui-icon
            >{{ helpText | translate }}
          </button>
        </li>
        <li>
          <button
            type="button"
            class="menu__item"
            (click)="openAclaraConnect()"
          >
            <ui-icon
              [name]="'aclara-connect'"
              [size]="iconSize"
              [color]="menuIconColor"
            ></ui-icon
            >{{ aclaraConnectText | translate }}
          </button>
        </li>
      </ul>
    }
  </div>

  @if (user$ | async; as user) {
    <div class="actions__anchor">
      <button
        type="button"
        class="actions__profile"
        (click)="toggle('user')"
      >
        <span class="actions__avatar">{{ user.initials }}</span>
        <ui-icon [name]="'caret-down'"></ui-icon>
      </button>
      @if (openMenu() === 'user') {
        <div class="menu menu--user">
          <div class="menu__user">
            <ui-icon
              [name]="'customer'"
              [color]="userIconColor"
              [size]="24"
            ></ui-icon>
            <span class="menu__name">{{ user.fullName }}</span>
            <span class="menu__email">{{ user.email }}</span>
          </div>
          <button
            type="button"
            class="menu__item"
            (click)="openUserSettings()"
          >
            <ui-icon
              [name]="'user-settings'"
              [color]="menuIconColor"
              [size]="iconSize"
            ></ui-icon
            >{{ userSettingsText | translate }}
          </button>
          <button
            type="button"
            class="menu__item"
            (click)="logout()"
          >
            <ui-icon
              [name]="'log-out'"
              [color]="menuIconColor"
              [size]="iconSize"
            ></ui-icon
            >{{ logoutText | translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
<aos-about-modal />
